import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputDate, InputNumber, InputMoney, InputSelect, InputPicklist } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './journal-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class JournalView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                <InputSelect name='status' label='status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <InputDate name='journaldate' label='Date' value={this.state.datarow.journaldate} readOnly/>
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} readOnly/>
                <InputSelect name='sign' label='Debet/Credit' value={this.state.datarow.sign} options={Model.optionSign} readOnly/>
                <InputMoney name='value' label='Value' value={this.state.datarow.value} readOnly/>
                <InputPicklist name='coa' label='COA' value={this.state.datarow.coa} caption={this.state.datarow.coaCaption} readOnly/>

            </BaseView>
        );
    }
}